import * as React from 'react';
import loc from 'owa-localize';
import { observer } from 'mobx-react-lite';
import { initialText, mandatoryLabelTitle } from './CLPMandatoryLabelModal.locstring.json';
import CLPLabel from 'owa-mail-protection-types/lib/schema/CLPLabel';
import getLabelDropdown from '../utils/clp/getLabelDropdown';
import { protectionStore } from 'owa-mail-protection/lib/store/protectionStore';
import CLPViewState from 'owa-mail-protection-types/lib/schema/clp/CLPViewState';
import { BaseButton } from '@fluentui/react/lib/Button';

const styles = require('./CLPMandatoryLabelModal.scss');
const classNames = require('classnames');

export interface MandatoryLabelModalProps {
    viewState: CLPViewState;
}

export default observer(function CLPMandatoryLabelModal(props: MandatoryLabelModalProps) {
    const { clpLabels } = protectionStore;
    const [selectedLabel, setSelectedLabel] = React.useState<CLPLabel>(null);

    const dropdownMenu = getLabelDropdown(clpLabels, setSelectedLabel, props.viewState);

    const commandbarButtonText = selectedLabel ? selectedLabel.displayName : loc(initialText);

    return (
        <BaseButton
            autoFocus={true}
            className={classNames(styles.commandBarButton)}
            text={commandbarButtonText}
            ariaLabel={loc(mandatoryLabelTitle)}
            menuProps={{ items: dropdownMenu }}
        />
    );
});
